<div *ngIf="loading" id="overlay">
    <span class="loader"></span>
</div>
